// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentInfo_container__CdPVQ","table":"PaymentInfo_table__3hinO"};